
export class MSG {
    Type: string = "MSG";
    Message: string;
}